import React from 'react';
import { useFormState } from 'react-final-form';
import { Link } from 'react-router-dom';

import { useTranslations } from 'shared/hooks';
import { Loader } from 'shared/components';
import { useDisabled } from './Button.utils';
import { ButtonProps } from './Button.types';
import { StyledButton, LoaderWrapper } from './Button.styles';

const ButtonBase: React.FC<ButtonProps> = React.forwardRef(({ loading, children, disabled, ...restProps }, ref) => {
  const { message } = useTranslations(children);

  const isDisabled = disabled || loading;

  return (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    // @ts-expect-error - Material-UI v4 styled component type conflict with React 18
    <StyledButton {...restProps} disabled={isDisabled} ref={ref as any}>
      {loading && (
        <LoaderWrapper>
          <Loader />
        </LoaderWrapper>
      )}
      {message}
    </StyledButton>
  );
});

const SubmitButton: React.FC<ButtonProps> = React.forwardRef((props, ref) => {
  const disabled = useDisabled(props);

  const { submitting } = useFormState({
    subscription: { submitting: true },
  });

  return <ButtonBase {...props} disabled={disabled} loading={submitting} ref={ref} />;
});

const LinkButton: React.FC<ButtonProps> = React.forwardRef((props, ref) => {
  // @ts-expect-error - Type conflict between @types/react versions with Link component
  return <ButtonBase component={Link} {...props} ref={ref} />;
});

export const Button: React.FC<ButtonProps> = React.forwardRef((props, ref) => {
  const { type, to } = props;

  if (typeof to !== 'undefined') {
    return <LinkButton {...props} ref={ref} />;
  }

  if (type === 'submit') {
    return <SubmitButton {...props} ref={ref} />;
  }

  return <ButtonBase {...props} ref={ref} />;
});
